<template>
    <v-container grid-list-md fluid class="py-0">
        <template v-if="isAuthorized">
            <div align-center v-for="(table, ti) in tables" :key="ti">
                <v-row class="d-flex justify-center">
                    <v-col :cols="firstColumnWidth" class="d-flex align-center">
                        <h1>{{ table.name }}</h1>
                        <v-btn-icon icon="$oss-download" @click.stop="download(table)" class="ml-2">
                        </v-btn-icon>
                        <v-btn-icon icon="$oss-duplicate" @click.stop="copy(table)"> </v-btn-icon>
                    </v-col>
                    <v-col cols="2" v-if="displayAccountingAvailabilityDate">
                        <v-select
                            v-model="accountingAvailabilityDate"
                            :items="endPublishDates"
                            item-value="value"
                            label="Publication au client"
                            elevation="0"
                            hide-details
                            :disabled="disabledPublishDate"
                            class="pl-2 flex-shrink-1 flex-grow-0"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end align-center" v-if="hasBeenCustomed">
                        <v-btn
                            rounded
                            elevation="0"
                            class="ml-2 mb-1"
                            @click.stop="resetAllCustomAmounts()"
                            size="x-small"
                        >
                            Revenir aux valeurs comptables
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-0">
                    <v-col
                        :cols="displayMonthlyData ? '12' : '8'"
                        class="d-flex justify-center"
                        v-if="loading"
                    >
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            class="mr-3 d-flex justify-center"
                        />
                    </v-col>
                    <v-col
                        :cols="displayMonthlyData ? '12' : currentKey === 'Bilan' ? '10' : '8'"
                        class="d-flex justify-center"
                        v-else
                    >
                        <v-data-table
                            :headers="getHeaders(table)"
                            :items="table.rows"
                            :height="`min(${numberVisibleLignes(table) * 38 + 2}px, ${maxHeight})`"
                            class="table"
                            fixed-header
                            hide-default-footer
                            :items-per-page="-1"
                            item-value="key"
                            density="compact"
                        >
                            <template #item="{ item }">
                                <tr
                                    class="text-left"
                                    v-if="item.title && !item.total"
                                    :style="itemRowBackground(item)"
                                >
                                    <td>
                                        <strong>{{ item.title }}</strong>
                                    </td>
                                    <td :colspan="getColumnCount(table)" />
                                    <!-- <td :colspan="getRowTitleColspan(table, pi)" v-for="(period, pi) in resultPeriods" :key="ti + '-' + pi" :style="addVerticalSeparatorStyle(table,table.columns.length-1,pi) ? verticalSepratorStyle:''">
                                    {{getRowTitleColspan(table, pi)}}</td>
                                    <td class="text-right" v-if="table.comparison && table.comparison.difference"></td>
                                    <td class="text-right" v-if="table.comparison && table.comparison.percentage"></td>
                                    <td class="text-right" :colspan="table.extraColumns.length" v-if="table.extraColumns && table.extraColumns.length && !displayMonthlyData"></td> -->
                                </tr>
                                <tr
                                    :style="itemRowBackground(item)"
                                    @click.stop="displayRowDetail(item)"
                                    v-else-if="withAmountOrNotOptional(item)"
                                >
                                    <td class="text-left" :style="colorElement(item)">
                                        {{ item.name || item.title }}
                                    </td>
                                    <template v-for="(period, pi) in resultPeriods">
                                        <template v-if="period.monthly">
                                            <td
                                                class="text-right pl-1"
                                                v-for="(month, index) of monthsToDisplay"
                                                :key="ti + '-' + pi + '-month' + index"
                                                @click.stop="
                                                    openEditCell(table, item, 0, pi, index)
                                                "
                                                :style="getCellStyle(table, item, 0, pi, index)"
                                            >
                                                {{
                                                    getAmountFormatted(
                                                        table,
                                                        item,
                                                        table.columns[0],
                                                        pi,
                                                        index,
                                                    )
                                                }}
                                            </td>
                                        </template>
                                        <td
                                            class="text-right"
                                            v-for="(col, ci) in table.columnsToDisplay[pi]"
                                            :key="ti + '-' + pi + '-' + ci"
                                            @click.stop="openEditCell(table, item, ci, pi)"
                                            :style="getCellStyle(table, item, ci, pi)"
                                        >
                                            {{ getAmountFormatted(table, item, col, pi) }}
                                        </td>

                                        <td
                                            class="text-right"
                                            v-if="table.getPercentageOfTotal && !displayMonthlyData"
                                            :key="ti + '-' + pi + '-relativePercentageMaxime'"
                                        >
                                            {{ getFormatedPercentageOfTotal(item, table, pi) }}
                                        </td>

                                        <td
                                            class="text-right"
                                            v-if="table.relativePercentage && !displayMonthlyData"
                                            :key="ti + '-' + pi + '-relativePercentage'"
                                        >
                                            {{ getRelativePercentage(item, pi) }}
                                        </td>
                                    </template>
                                    <td
                                        class="text-right"
                                        v-if="
                                            table.comparison &&
                                            table.comparison.difference &&
                                            !displayMonthlyData
                                        "
                                    >
                                        {{ formatDifference(item) }}
                                    </td>
                                    <td
                                        class="text-right"
                                        v-if="
                                            table.comparison &&
                                            table.comparison.percentage &&
                                            !displayMonthlyData
                                        "
                                    >
                                        {{ formatPercentage(item.percentage) }}
                                    </td>
                                    <template v-if="table.extraColumns && !displayMonthlyData">
                                        <td
                                            class="text-right"
                                            v-for="column in table.extraColumns"
                                            :key="column.name"
                                        >
                                            {{ getExtraColumnsValue(item, column.name) }}
                                        </td>
                                    </template>
                                </tr>
                                <template
                                    v-if="item.isExpanded && item.subRows && item.subRows.length"
                                >
                                    <tr
                                        v-for="(subrow, subR) in item.subRows"
                                        :key="ti + '-' + item.name + '-' + subR"
                                        class="elevation-1 border-0"
                                        style="cursor: pointer"
                                    >
                                        <td
                                            class="text-left font-italic"
                                            @click="openAABDetailDialog(subrow.name, subrow)"
                                        >
                                            &emsp; &emsp; &emsp;{{
                                                subrow.name + " - " + subrow.description
                                            }}
                                        </td>
                                        <template v-for="(period, pi) in resultPeriods">
                                            <template v-if="period.monthly && monthsToDisplay">
                                                <td
                                                    v-for="(month, index) of monthsToDisplay"
                                                    :key="
                                                        ti +
                                                        '-' +
                                                        item.name +
                                                        '-' +
                                                        pi +
                                                        '-' +
                                                        subR +
                                                        '-' +
                                                        index
                                                    "
                                                    class="text-right font-italic"
                                                >
                                                    <!-- @click.stop="openEditCell(table, item, 0, pi, month, subrow)"   :style="getCellStyle(table, item, 0, pi, month, subrow)" -->
                                                    {{
                                                        getSubMonthlyAmount(
                                                            table,
                                                            item,
                                                            subrow,
                                                            pi,
                                                            index,
                                                        )
                                                    }}
                                                </td>
                                            </template>
                                            <td
                                                v-for="(col, ci) in table.columnsToDisplay[pi]"
                                                :key="ti + '-' + pi + '-' + ci + '-' + subR"
                                                class="text-right font-italic"
                                                @click.stop="
                                                    openEditCell(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                "
                                                :style="
                                                    getCellStyle(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                "
                                            >
                                                {{
                                                    getAmountFormatted(
                                                        table,
                                                        item,
                                                        col,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                }}
                                                <!-- {{getAmountSubRow(table, item, subrow.values, pi, ci)}} -->
                                            </td>
                                            <td
                                                class="text-right"
                                                v-if="
                                                    table.getPercentageOfTotal &&
                                                    !displayMonthlyData
                                                "
                                                :key="ti + '-' + pi + '-relativePercentageMaxime'"
                                            >
                                                {{ "" }}
                                            </td>
                                            <td
                                                class="text-right"
                                                v-if="table.relativePercentage"
                                                :key="
                                                    ti +
                                                    '-' +
                                                    pi +
                                                    '-relativePercentage' +
                                                    '-' +
                                                    subR
                                                "
                                            >
                                                {{ getRelativePercentage(subrow, pi) }}
                                            </td>
                                        </template>
                                        <td
                                            class="text-right"
                                            v-if="table.comparison && table.comparison.difference"
                                        />
                                        <td
                                            class="text-right"
                                            v-if="table.comparison && table.comparison.percentage"
                                        />
                                        <template v-if="table.extraColumns">
                                            <td
                                                class="text-right"
                                                v-for="column in table.extraColumns"
                                                :key="column.name"
                                            />
                                        </template>
                                    </tr>
                                </template>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
            <oss-dialog v-model="AABDialog" v-if="AABDialog">
                <v-row>
                    <v-col>
                        <AccountableAccountBalanceDetail
                            :companyId="companyId"
                            :accountingPeriodId="accountingPeriodId"
                            :accountableAccountInfo="accountableAccountInfo"
                            :startDate="date.start"
                            :endDate="date.end"
                            @refresh="refresh"
                        />
                    </v-col>
                </v-row>
            </oss-dialog>
            <oss-dialog
                v-model="showEditCellDialog"
                title="Edition"
                @valid="saveEditCell()"
                v-if="showEditCellDialog"
                width="500px"
            >
                <v-row no-gutters>
                    <v-col cols="12">
                        <oss-text-field-filled
                            label="Montant"
                            single-line
                            class="mt-2"
                            autofocus
                            v-model="cellToEdit.value"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-end">
                        <v-btn
                            v-if="ifCellToEditAlreadyModified"
                            @click.stop="resetCustomAmount"
                            size="x-small"
                        >
                            Réinitialiser la valeur
                        </v-btn>
                    </v-col>
                </v-row>
            </oss-dialog>
        </template>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { AccountingSheet } from "./AccountingSheet";
import AccountableAccountBalanceDetail from "../AccountableAccountBalanceDetail.vue";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";
// Queries to get balances
import ACCOUNTING_TABLE from "../../graphql/dashboardAccounting/AccountingTable.gql";
import OPERATING_ACCOUNT_QUERY from "../../graphql/tag/OperatingAccounts.gql";
import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import ACCOUNTING_FIRM_CLIENT from "../../graphql/billing/AccountingFirmClient.gql";
import UPSERT_ACCOUNTING_FIRM_CLIENT from "../../graphql/billing/UpsertAccountingFirmClient.gql";

import { DashBoardTableStream } from "../../services/dashboardTableStream";
import { getAccountingPublishDates } from "../../services/accountingPeriods";
import ExcelServices from "../../services/excelServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["table"],
    components: {
        AccountableAccountBalanceDetail,
    },
})
export class AccountingTable extends AccountingSheet {
    @Prop({ default: "" }) operatingAccountId: any; // either operatingAccountId or options
    @Prop({ default: null }) options: any; // format : { title:String, className:String, accountingPeriodRequired ? :boolean}

    @Prop({ default: "" }) budgetId: any;

    @Prop({ default: null }) myKey: String;
    @Prop({ default: null }) currentKey: String;
    @Prop({ default: false }) withSelector: boolean;

    //
    accountingAvailabilityDate = "";
    disabledPublishDate: boolean = false;
    // refreshKey = 0

    get currentUser(): User {
        return this.$store?.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get endPublishDates() {
        return getAccountingPublishDates(this.$store);
    }

    readonly oldClassNames = ["INCOME_STATEMENT", "BALANCE_SHEET", "SIG", "FLASH_SITUATION"];

    getQuery() {
        return ACCOUNTING_TABLE;
    }

    get selectedCompanyId() {
        // debugger
        return this.$store?.state.selected_company?.id || "";
    }

    get resultKey() {
        // if (this.options) return this.options.title
        // debugger
        return "accountingTable";
    }

    get title() {
        if (this.options) return this.options.title;
        debugger;
        return "";
    }

    get type() {
        if (this.options) return this.options.type;
        debugger;
        return "";
    }

    get className() {
        if (this.options) {
            if (!this.oldClassNames.includes(this.options.className)) {
                return this.options.className || "OperatingAccountCustom";
            }
        }
        return "OperatingAccountCustom";
    }

    get isAccountingPeriodRequired() {
        if (this.options) return this.options.accountingPeriodRequired;
        return false;
    }

    get skipApollo() {
        if (!this.myKey || !this.currentKey) {
            return false;
        } else {
            if (this.myKey !== this.currentKey) {
                return true;
            }
            if (this.myKey !== "Bilan" && this.myKey !== "3") {
                if (!this.operatingAccountId_) {
                    return true;
                }
            }
            return false;
        }
    }

    get operatingAccountId_() {
        if (this.operatingAccountIdFromOptions) {
            return this.operatingAccountIdFromOptions;
        }
        return this.operatingAccountId;
    }

    get maxHeight() {
        let height = 252;
        if (this.withSelector) {
            height += 46;
        }
        if (this.hasBeenCustomed) {
            height += 24;
        }
        return "calc(100vh - " + height + "px)";
    }

    // getAmountSubRow(table, row, subRow, pi, ci) {
    //     const col = table.columns[ci]
    //     if (subRow[col.key]) {
    //         let amount = subRow[col.key][pi]
    //         if (row.displaySign) {
    //             amount *= row.displaySign
    //         }
    //         if (amount) {
    //             return this.newCommonFormatCurrency(amount, undefined)
    //         }
    //     }
    //     return "-"
    // }

    getSubMonthlyAmount(table, row, subRow, pi, month) {
        const col = table.columns[0];
        if (subRow.monthlyAmounts?.[col.key]?.[month] !== undefined) {
            let amount = subRow.monthlyAmounts[col.key][month];
            if (row.displaySign) {
                amount *= row.displaySign;
            }
            return this.newCommonFormatCurrency(amount, undefined);
        }
        return "-";
    }

    async resetAllCustomAmounts() {
        await this.dashboardTable.resetAllCustomAmounts();
        this.hasBeenCustomed = false;
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.company?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    @Apollo({
        query: ACCOUNTING_FIRM_CLIENT,
        variables() {
            return {
                clientId: this.selectedCompanyId,
                accountingFirmId: this.accountingFirm.id,
            };
        },
        skip() {
            return !this.selectedCompanyId || !this.accountingFirm?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClientFirst) {
                    this.accountingFirmClient = data.accountingFirmClientFirst;
                    if (this.accountingFirmClient?.accountingAvailabilityDate) {
                        this.accountingAvailabilityDate = moment(
                            this.accountingFirmClient.accountingAvailabilityDate,
                        ).format("YYYY-MM-DD");
                    } else {
                        this.accountingAvailabilityDate = "";
                    }
                } else {
                    this.accountingFirmClient = null;
                }
            }
        },
    })
    accountingFirmClient = null;

    get isAccountingClientUser() {
        if (!this.accountingFirm) {
            return true;
        }
        if (this.accountingFirm.id === this.currentUser.company.id) {
            return false;
        }
        return true;
    }

    @Apollo({
        query() {
            return this.getQuery();
        },
        variables() {
            return {
                companyId: this.companyId,
                className: this.className,
                budgetId: this.budgetId,
                periods: this.periods,
                tags: this.myKey !== "Bilan" ? this.tags || undefined : undefined,
                operatingAccountId: this.operatingAccountId_,
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return (
                !this.companyId ||
                !this.className ||
                (!this.periods?.length && !this.budgetId) ||
                !this.getQuery() ||
                this.skipApollo ||
                !this.accountingPeriodId ||
                (this.className === "OperatingAccountCustom" && !this.operatingAccountId_)
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            console.log("data : ", data);
            this.loading = loading;
            if (!loading && data) {
                if (data[this.resultKey]) {
                    const output = data[this.resultKey].output;
                    for (const table of output.tables) {
                        for (const r of table.rows) {
                            r.isExpanded = false;
                        }
                        this.setColumnsToDisplay(output, table, output.periods);
                    }
                    this.output = output;
                    this.tables = this.output.tables || [];
                    this.resultPeriods = this.output.periods || [];
                    this.computeTableHeaders();
                    const customAmounts = this.output.customAmounts;
                    this.dashboardTable = new DashBoardTableStream(
                        this.$apollo,
                        this.resultPeriods,
                        this.tables,
                        this.accountingPeriodId,
                        customAmounts,
                    );
                    this.updateAmounts();
                    this.$emit("table", this.tables);
                }
            }
        },
    })
    output = {
        resultPeriods: [],
        tables: [],
    };

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.output) {
            this.$apollo.queries.output.refetch();
        }
        this.AABDialog = false;
    }

    @Apollo({
        query() {
            return OPERATING_ACCOUNT_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                use: "OPERATING_ACCOUNT",
            };
        },
        skip() {
            return this.operatingAccountId || !this.options?.className;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.scopingOperatingAccount?.data?.length) {
                    this.operatingAccountIdFromOptions = data.scopingOperatingAccount.data.find(
                        (e) => e.type === this.options.className,
                    )?.id;
                }
            }
        },
    })
    operatingAccountIdFromOptions = "";

    get loading() {
        if (this.$apollo.queries.output) {
            return this.$apollo.queries.output.loading;
        }
        return false;
    }

    set loading(value) {}

    displayRowDetail(item) {
        if (item && !item.dontDisplayDetail) {
            item.isExpanded = !item.isExpanded;
        }
    }

    numberVisibleLignes(table): number {
        let result = table.rows?.length ? table.rows.length + 1 : 0;
        for (const row of table.rows) {
            if (row.isExpanded) {
                if (row.subRows?.length) {
                    result += row.subRows.length * 1.01; // expandedLines are a little bigger
                }
            }
        }
        return result;
    }

    //
    // edition
    //
    cellToEdit = {
        row: null,
        pi: -1,
        ci: -1,
        colKey: "",
        mi: undefined,
        subrow: undefined,
        value: 0,
    };

    showEditCellDialog: boolean = false;

    openEditCell(
        table,
        row: any,
        ci: number,
        pi: number,
        mi: number = undefined,
        subrow = undefined,
    ) {
        if (this.isCellEditable(row, pi)) {
            this.cellToEdit.row = row;
            this.cellToEdit.pi = pi;
            this.cellToEdit.ci = ci;
            this.cellToEdit.colKey = table.columns[ci].key;
            this.cellToEdit.mi = mi;
            this.cellToEdit.subrow = subrow;
            if (subrow) {
                this.cellToEdit.value =
                    mi === undefined
                        ? this.getSubRowAmount(table, row, subrow, ci, pi)
                        : this.getSubRowMonthlyAmount(table, row, subrow, ci, pi, mi);
            } else {
                this.cellToEdit.value =
                    mi === undefined
                        ? this.getAmount(table, row, ci, pi)
                        : this.getMonthlyAmount(table, row, ci, pi, mi);
            }
            if (row.displaySign) {
                this.cellToEdit.value *= row.displaySign;
            }
            if (isNaN(this.cellToEdit.value)) {
                debugger;
                this.cellToEdit.value = 0.0;
            }
            this.showEditCellDialog = true;
        }
    }

    async saveEditCell() {
        if (this.cellToEdit?.row?.displaySign) {
            this.cellToEdit.value *= this.cellToEdit.row.displaySign;
        }
        await this.dashboardTable.setCustomAmount(this.cellToEdit);
        this.showEditCellDialog = false;
    }

    async resetCustomAmount() {
        await this.dashboardTable.resetCustomAmount(
            this.cellToEdit.row,
            this.cellToEdit.colKey,
            this.cellToEdit.pi,
            this.cellToEdit.mi,
        );
        this.showEditCellDialog = false;
    }

    ifCellToEditAlreadyModified() {
        const subRowName = this.cellToEdit.subrow ? this.cellToEdit.subrow.name : undefined;
        return this.dashboardTable.isCustomAmount(
            this.cellToEdit.row,
            this.cellToEdit.colKey,
            this.cellToEdit.pi,
            this.cellToEdit.mi,
            subRowName,
        );
    }

    @Watch("accountingAvailabilityDate")
    async onChanged() {
        if (this.selectedCompanyId && this.accountingFirm.id) {
            const result = await this.$apollo.mutate({
                mutation: UPSERT_ACCOUNTING_FIRM_CLIENT,
                variables: {
                    id: this.accountingFirmClient?.id || "",
                    accountingFirmId: this.accountingFirm.id,
                    clientId: this.selectedCompanyId,
                    accountingAvailabilityDate: this.accountingAvailabilityDate
                        ? moment(this.accountingAvailabilityDate).utc(true).format()
                        : null,
                },
            });
            if (result.data?.upsertAccountingFirmClient) {
                this.accountingFirmClient = result.data.upsertAccountingFirmClient;
            }
        }
    }

    download(table) {
        const excelServices = new ExcelServices();
        excelServices.exportAccountingTable(table, this.periods, null, this.companyName);
    }

    copy(table) {
        const excelServices = new ExcelServices();
        excelServices.copyToClipboardAccountingTable(table, this.periods, null, this.companyName);
    }

    get displayAccountingAvailabilityDate(): boolean {
        return (
            this.isAccountingUser && !this.isAccountingClientUser && this.type === "FLASH_SITUATION"
        );
    }

    get firstColumnWidth(): number {
        let baseWidth = this.displayMonthlyData ? 12 : this.currentKey === "Bilan" ? 10 : 8;
        if (this.displayAccountingAvailabilityDate) baseWidth -= 2;
        if (this.hasBeenCustomed) baseWidth -= 2;
        return baseWidth;
    }
}

export default toNative(AccountingTable);
</script>
